
export const sitemap = (router) => ({
    type: 'UPDATE_ROUTER',
    router
});


export const login = (user) => ({
  type: 'APPS_LOGIN',
  user
});

export const toggle = (collapse) => ({
  type: "APPS_MENU",
  collapse
});